//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import CircularProgress from "@material-ui/core/CircularProgress";
import base64 from 'base-64';

//components
import Alerta from '../../../../../util/snackbars/.mixins/';
import Section from '../childrens/Section/.mixins/Section';

//constrollers
import Config from '../../../../../../controllers/config';
import Pessoa_controller from '../../../../../../controllers/pessoa';
import Comunicado_controller from '../../../../../../controllers/comunicado';
import Contato_controller from '../../../../../../controllers/contato';
import Grupo_controller from '../../../../../../controllers/grupo';
import Log from '../../../../../../controllers/log';

//hooks
import { useApi } from 'services/api';
import { useEnvironment } from 'hooks';

//css
import ComunicadosContatosAeCss from './Comunicados_contatos_ae-css';
const useStyles = ComunicadosContatosAeCss();

function ComunicadosContatosAeC(props) {
    const classes = useStyles();
    return(
        <div>
            {props.state.isLoading &&
                <div align="center">
                    <CircularProgress />
                </div>
            }
            {!props.state.isLoading &&
                <Section {...props}/>
            }
            <Alerta ref={props.child}/>
        </div>
    );
}

export default class Ae_mini_list extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.state = {
            id: null,
            titulo: '',
            descricao: '',
            lancamento: new Date(),
            termino: new Date(),
            isLoading: true,
            arquivo: '',
            arquivoName: '',
            rota: '',
            arquivoIndicacao: null,
            arquivoIndicacaoNome: null,
            arquivoIndicacaoDisplay: true,
            diretorio: null,
            fl_all: true,
            gruposArray: null,
            grupo_id: 0,
            disabled: {
                rota: false,
                arquivo: false
            },
            editFileMode: false,
            fornecedores: [],
            tipo: 'Adicionar'
        }

        this.setState = this.setState.bind(this);
        this.fl_authCheck = this.fl_authCheck.bind(this);
        this.sendForm = this.sendForm.bind(this);
    }

    componentDidMount() {

        //carrega dados
        this.carregarInformacoes();

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela formulário de "+this.props.route.title+"!");

    }

    async carregarInformacoes() {

        if (this.props && this.props.params && this.props.params.id) {
            this.setState({tipo: 'Editar'});
            await this.carregarDados();
        }

        if (this.props.route.title.includes('contato'))
            await this.carregarGrupos();

        if (this.props.route.title.includes('comunicado') && this.props.params.id != null)
            await this.checkFornecedoresAll(this);

        if (this.props.route.title.includes('comunicado') && this.props.params.id != null)
            this.setState({editFileMode: false});

        if (this.props.route.title.includes('contato') && this.props.params.id != null)
            this.setState({editFileMode: false});

        if (this.state.tipo == "Adicionar")
            this.setState({editFileMode: true});

        this.setState({isLoading: false});
    }

    oracleToDate(valor) {
        var data = valor.substring(0,16);
        data = data.replace( /(\d{2})-(\d{2})-(\d{4}) (\d{5}):(\d{6})/, "$2/$1/$3 $5:$6");
        data = data.replace(' ','T');
        return data;
    }

    verificaFile(diretorio) {
        if (diretorio.includes(';@Assets'))
            return '';
        else
            return diretorio;
    }

    fl_authCheck() {
        if (this.state.fl_autentificado === 0)
            this.setState({fl_autentificado:1})
        else
            this.setState({fl_autentificado:0})
    }

    async checkFornecedoresAll(props) {
        const filters = {tipo: "F"};
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            const r_fornecedores = await Pessoa_controller.getFornecedoresByIdF(token,props.props.params.id, filters);
            const j_r_fornecedores = JSON.parse(r_fornecedores.body);

            if (j_r_fornecedores.status) {
                var count = 0;
                j_r_fornecedores.itens.forEach(element => {
                    if (!eval(element.VISIVEL.toLowerCase()))
                        count++;
                });
                if (count > 0) {
                    props.setState({
                        fl_all: false
                    });
                }
            } else {
                props.child.current.retorno('Erro ao carregar dados!','error');
            }

            //auditoria
            var str = "Efetuada requisição para recuperação de dados de fornecedores! "
            +"Response:( Method: "+r_fornecedores.res.request.method
            +", StatusCode: "+r_fornecedores.res.statusCode
            +", Body: (limited 100chars)"+r_fornecedores.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            props.child.current.retorno('Erro na recuperação de dados de fornecedores!','error');

            //auditoria
            var str = "Erro na recuperação de dados de fornecedores! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    async carregarGrupos() {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            //Carrega dados nos campos
            const r_dados = await Grupo_controller.get(token);
            const j_r_dados = JSON.parse(r_dados.body);

            if (r_dados.res.statusCode == 200) {
                this.setState({gruposArray: j_r_dados.itens});
            } else if (j_r_dados.message === 'Token inválido!') {
                this.child.current.retorno('Autentificação inválida!','error');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.child.current.retorno('Não foi possível carregador os dados!','error');
            }

            //auditoria
            var str = "Efetuada requisição para recuperação de dados de grupos! "
            +"Response:( Method: "+r_dados.res.request.method
            +", StatusCode: "+r_dados.res.statusCode
            +", Body: (limited 100chars)"+r_dados.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            this.child.current.retorno('Erro na recuperação de dados de grupos!','error');

            //auditoria
            var str = "Erro na recuperação de dados de grupos! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }
    }

    async carregarDados() {
        var falha = 0;
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {

            //monta request
            var m_params = {};
            var params = {};
            m_params['uri'] = '/'+this.props.route.title+'/'+this.props.params.id;
            m_params['method'] = 'GET';
            params['token'] = token;
            params['body'] = null;
            var r_dados = null;

            //faz request
            if (this.props.route.title.includes('contato'))
                r_dados = await Contato_controller.any(params,m_params);
            else
                r_dados = await Comunicado_controller.any(params,m_params);

            //converte json do body para object
            var j_r_dados = await r_dados.json();

            //checa resultado
            if (r_dados.status) {
                falha = 0;
            } else if (j_r_dados.message === 'Token inválido!') {
                falha = 2;
            } else {
                falha = 1;
            }

            if (falha === 0) {
                var obj = j_r_dados.itens[0];
                this.setState({
                    titulo: obj.titulo,
                    descricao: obj.descricao,
                    lancamento: new Date(obj.lancamento),
                    termino: new Date(obj.termino),
                    fl_autentificado: obj.fl_autentificado,
                    rota: obj.diretorio,
                    diretorio: obj.diretorio
                });
                if (obj.grupo_id != null)
                    this.setState({grupo_id: obj.grupo_id});
                if (obj.diretorio != null && obj.diretorio.includes(";@Assets/")) {
                    var ain = obj.diretorio.split("/");
                    ain = ain[ain.length-1];
                    this.setState({
                        arquivo: obj.anexo,
                        arquivoIndicacaoNome: ain,
                        rota: this.verificaFile(obj.diretorio),
                        arquivoIndicacao: `${this.props.route.title}s/arquivos/${this.props.params.id}`
                    });
                }

            } else if (falha === 1) {
                this.child.current.retorno('Não foi possível carregador os dados!','error');
            } else if (falha === 2) {
                this.child.current.retorno('Autentificação inválida!','error');
                setTimeout(function() {
                    window.location.reload();
                }, 1000);
            }

            //auditoria
            var str = "Efetuada requisição para recuperação de dados de "+this.props.route.title+"s! "
            +"Response:( Method: "+r_dados.method
            +", StatusCode: "+r_dados.status
            +", Body: (limited 100chars)"+j_r_dados.toString().substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            this.child.current.retorno('Erro na recuperação de dados de '+this.props.route.title+'s!','error');

            //auditoria
            var str = "Erro na recuperação de dados de "+this.props.route.title+"s! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }


    }

    tmISO(dt) {
        dt = new Date(dt);
        var tzo = -dt.getTimezoneOffset(),
            dif = tzo >= 0 ? '+' : '-',
            pad = function(num) {
                var norm = Math.floor(Math.abs(num));
                return (norm < 10 ? '0' : '') + norm;
            };
        return dt.getFullYear() +
            '-' + pad(dt.getMonth() + 1) +
            '-' + pad(dt.getDate()) +
            'T' + pad(dt.getHours()) +
            ':' + pad(dt.getMinutes()) +
            ':' + pad(dt.getSeconds()) +
            dif + pad(tzo / 60) +
            ':' + pad(tzo % 60);
    }

    async marcarFornecedores() {
        return new Promise(async resolve => {

            //chama cookie para declarar token
            const cookies = new Cookies();
            const token = cookies.get('User-Token');

            try {

                if (this.state.fl_all) {

                    const r_fornecedores = await Pessoa_controller.getFornecedores(token);
                    var j_r_fornecedores = JSON.parse(r_fornecedores.body);

                    //auditoria
                    var str = "Efetuada requisição para recuperação de dados de fornecedores! "
                    +"Response:( Method: "+r_fornecedores.res.request.method
                    +", StatusCode: "+r_fornecedores.res.statusCode
                    +", Body: (limited 100chars)"+r_fornecedores.body.substr(0,100)
                    +" )";
                    Log.info(token,str);

                    if (j_r_fornecedores.status) {
                        var array = [];
                        j_r_fornecedores.itens.forEach(element => {
                            array.push({
                                ID_PESSOA: element.ID_PESSOA,
                                id_cfg: 0,
                                email: element.RET_EMAIL_PESSOA
                            });
                        });
                        return resolve(array);
                    } else {
                        throw Error("Não foi possivel carregar fornecedores!");
                    }

                } else {
                    return resolve(this.state.fornecedores);
                }

            } catch (error) {

                this.child.current.retorno(error.message,'error');

                //auditoria
                var str = "Erro na recuperação de dados de fornecedores! "
                +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
                Log.error(token,str);

                return null;

            }

        });
    }

    validacoes() {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            //validações
            if (this.state.titulo === '')
                throw new Error("Preencha o campo titulo!");

            if (this.state.titulo.length > 50)
                throw new Error("Campo titulo não pode ter mais de 50 caracteres!");

            if (this.state.titulo.match(/\t/))
                throw new Error("Caracteres inválidos em campo titulo!");

            if (this.state.descricao.length > 250)
                throw new Error("Campo descrição não pode ter mais de 250 caracteres!");

            if (this.state.descricao === '')
                throw new Error("Preencha o campo descrição!");

            if (this.state.descricao.match(/\t/))
                throw new Error("Caracteres inválidos em campo descricao!");

            if (this.state.lancamento === '')
                throw new Error("Preencha o campo lancamento!");

            if (this.state.termino === '')
                throw new Error("Preencha o campo termino!");

            if (this.props.route.title.includes("contato") && this.state.grupo_id == 0)
                throw new Error("Preencha o campo grupo!");

            if (this.state.rota != '' && !this.state.rota.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)) {
                throw new Error("Rota não é uma url válida!");
            } else {
                if (!this.state.rota.includes("http://") && !this.state.rota.includes("https://"))
                    this.state.rota = `https://${this.state.rota}`;
            }

            return true;

        } catch (error) {
            this.child.current.retorno(error.message,'warning');

            //auditoria
            var str = "Alerta na validação do formulário de "+this.state.title+"! "
            +"Warning:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.warning(token,str);

            return false;
        }
    }

    async envioDados(m_params,data) {
        //chama cookie para declarar token
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        var result, str = null;
        try {
            //define parametros que irao para requisicao
            var params = {
                token: token,
                body: data
            };

            //envio de dados
            if (this.props.route.title.includes("comunicado")) {
                result = await Comunicado_controller.any(params,m_params);
                const { api, paths } = useApi();
                const fornecedores = await this.marcarFornecedores();
                const suppliersEmailList = fornecedores.map((fornecedor) => fornecedor.email);
                const { NODE_ENVIRONMENT } = useEnvironment;

                const mailParams = {
                  title: 'Novo comunicado!',
                  content: `Você possui um novo Comunicado: "${data.get('Titulo')}" <br />
                            <a href="${NODE_ENVIRONMENT === 'prd' ? 'https://fornecedores.tokstok.com.br/#/' : 'https://fornecedores-hml.gotokstok.net/#/'}">Clique aqui</a> para acessar o Portal dos Fornecedores e visualizá-lo.`,
                  recipientEmailList: suppliersEmailList
                }

                await api.post(paths.contact.sendMailToSuppliers, mailParams, {
                  headers: { userFunctionKey: 'd82c8d1619ad8176d665453cfb2e55f0' }
                });
            } else {
                result = await Contato_controller.any(params,m_params);
            }

            //auditoria
            str = "Efetuada requisição de envio de dados de "+this.props.route.title+"s! "
            +"Response:( Method: "+this.state.method
            +", StatusCode: "+result.status
            +" )";
            Log.info(token,str);

            //checa o tipo de retorno
            if (result.status === 200) {
                var t = "adicionado";
                if (this.state.tipo != "Adicionar")
                    t = "editado";
                this.child.current.retorno(this.capitalizeFirstLetter(this.props.route.title)+" "+t+" com sucesso!",'success');
                setTimeout(() => {
                    this.props.router.goBack();
                }, 1000);
            } else {
                this.child.current.retorno('Não foi possível '+this.state.tipo.toLowerCase()+' o '+this.props.route.title+'!','error');
                setTimeout(() => {
                    this.props.router.goBack();
                }, 1000);
            }

        } catch (error) {
            //auditoria
            str = "Erro ao recuperar dados de "+this.props.route.title+"s! "
            +"Erro:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    async sendForm() {
        //chama cookie para declarar token
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        var str = null;

        try {
            //declaracao de variaveis auxiliares
            var formData = new FormData();
            var m_params = {};

            //validações
            if (!this.validacoes())
                return null;

            //faz captura de arquivo no campo
            if(
                this.state.editFileMode &&
                document.querySelector('input[type="file"]') != null &&
                document.querySelector('input[type="file"]').files.length != 0
            ) {
                var file = document.querySelector('input[type="file"]').files[0];
                var base64 = await this.toBase64(file);
                formData.append("Doc", base64.split(",")[1]);
                formData.append("Diretorio", `application/pdf;@Assets/${this.props.route.title}/${file.name}`);
            } else if (this.state.arquivo != "") {
                formData.append("Doc", this.state.arquivo);
                formData.append("Diretorio", this.state.diretorio);
            }

            if (this.state.rota != "") {
                formData.append("Diretorio", this.state.rota);
            }

            //mostra loader
            this.setState({isLoading:true});

            //verificar tipo do metodo
            if (this.state.tipo === 'Adicionar') {
                m_params['uri'] = '/'+this.props.route.title;
                m_params['method'] = 'POST';
            } else {
                m_params['uri'] = '/'+this.props.route.title+'/'+this.props.params.id;
                m_params['method'] = 'PUT';
            }

            //carrega parametros enviados no body
            formData.append("Titulo", this.state.titulo);
            formData.append("Descricao", this.state.descricao);

            if (this.props.route.title.includes('contato')) {
                formData.append("Grupo", this.state.grupo_id);
            }

            if (this.props.route.title.includes('comunicado')) {
                formData.append("Lancamento", this.tmISO(this.state.lancamento));
                formData.append("Termino", this.tmISO(this.state.termino));
                formData.append("Fl_all", this.state.fl_all);

                //define lista de fornecedores dentro do param fornecedores
                if (!this.state.fl_all) {
                    const r_fornec = await this.marcarFornecedores();
                    if (r_fornec == null)
                        return null;
                    else
                        formData.append("Fornecedores", JSON.stringify(r_fornec));
                } else {
                    formData.append("Fornecedores", JSON.stringify([]));
                }
            }

            //envio de dados
            this.envioDados(m_params,formData);
        } catch (error) {
            //auditoria
            str = "Erro ao recuperar dados de "+this.props.route.title+"s! "
            +"Erro:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    render() {
        return <ComunicadosContatosAeC {...this}/>;
    }
}
